import React from 'react'
import PropTypes from 'prop-types'
import styles from './UnderlineSlatePlugin.scss'

const UnderlineNode = ({ attributes, children }) => (
  <span {...attributes} style={{textDecoration: 'underline'}} className={styles.UnderlineNode}>
    {children}
  </span>
)

UnderlineNode.propTypes = {
  attributes: PropTypes.object,
  children: PropTypes.node
}

export default UnderlineNode



// WEBPACK FOOTER //
// ./src/components/UnderlineSlatePlugin/UnderlineNode.js